import React, { createContext, useContext, useState } from 'react';
import Modal from '../components/Modal';

const ModalContext = createContext();

export function ModalProvider({ children }) {
  const [modal, setModal] = useState(null);

  const showModal = ({ title, message, type = 'info', onConfirm, onCancel, confirmText = 'OK', cancelText = 'Cancel', showCancel = false }) => {
    return new Promise((resolve) => {
      setModal({
        title,
        message,
        type,
        confirmText,
        cancelText,
        showCancel,
        onConfirm: () => {
          if (onConfirm) onConfirm();
          resolve(true);
        },
        onCancel: () => {
          if (onCancel) onCancel();
          resolve(false);
        },
        onClose: () => {
          setModal(null);
          resolve(false);
        }
      });
    });
  };

  const alert = (message, title = 'Notification', type = 'info') => {
    return showModal({ title, message, type, showCancel: false });
  };

  const confirm = (message, title = 'Confirm', type = 'warning') => {
    return showModal({ 
      title, 
      message, 
      type, 
      showCancel: true,
      confirmText: 'OK',
      cancelText: 'Cancel'
    });
  };

  const closeModal = () => {
    setModal(null);
  };

  return (
    <ModalContext.Provider value={{ showModal, alert, confirm, closeModal }}>
      {children}
      {modal && (
        <Modal
          isOpen={true}
          onClose={modal.onClose}
          title={modal.title}
          message={modal.message}
          type={modal.type}
          onConfirm={modal.onConfirm}
          onCancel={modal.onCancel}
          confirmText={modal.confirmText}
          cancelText={modal.cancelText}
          showCancel={modal.showCancel}
        />
      )}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within ModalProvider');
  }
  return context;
}
